import { render, staticRenderFns } from "./BundlePpiPage.vue?vue&type=template&id=4a19c5b2&scoped=true&"
import script from "./BundlePpiPage.vue?vue&type=script&lang=ts&"
export * from "./BundlePpiPage.vue?vue&type=script&lang=ts&"
import style0 from "./BundlePpiPage.vue?vue&type=style&index=0&id=4a19c5b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a19c5b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VChipGroup,VDivider,VIcon,VSpacer})
